export function calculateDistance(
  firstPoint: {lat: number; lon: number},
  secondPoint: {lat: number; lon: number},
  unit = 'kilometre',
) {
  // earth's radius measured in both kilometers and miles for distance calculations
  const EARTH_RADIUS_KM = 6371;
  const EARTH_RADIUS_MILES = 3959;

  const earthRadius = unit === 'miles' ? EARTH_RADIUS_MILES : EARTH_RADIUS_KM;

  // utility function to convert degree measurements to radian measurements for trigonometric calculations
  const degreesToRadians = (degrees: number) => degrees * (Math.PI / 180);

  // find the difference between the two coordinate points in both latitude and longitude
  const latitudeDifference = degreesToRadians(secondPoint.lat - firstPoint.lat);
  const longitudeDifference = degreesToRadians(
    secondPoint.lon - firstPoint.lon,
  );

  // convert both coordinate points from degrees to radians for use in haversine formula
  const firstPointLatInRadians = degreesToRadians(firstPoint.lat);
  const secondPointLatInRadians = degreesToRadians(secondPoint.lat);

  // calculate the haversine formula's 'a' value using the differences and converted coordinates
  const haversineA =
    Math.sin(latitudeDifference / 2) ** 2 +
    Math.cos(firstPointLatInRadians) *
      Math.cos(secondPointLatInRadians) *
      Math.sin(longitudeDifference / 2) ** 2;

  // calculate the haversine formula's 'c' value which represents the angular distance
  const haversineC =
    2 * Math.atan2(Math.sqrt(haversineA), Math.sqrt(1 - haversineA));

  // multiply the angular distance by earth's radius to get the actual distance between points
  const distanceInSpecifiedUnit = earthRadius * haversineC;

  return distanceInSpecifiedUnit;
}
